((app, ng) => {

    app.component("myReports",
        {
            templateUrl: "/App/Dashboard/Tiles/MyReports/my-reports.template.html",
            controller: myReportsController,
            bindings: {
                currentUser: "<"
            }
        });

    function myReportsController($q, $state, reportApi) {
        const $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                loading: false
            },
            searchText: ''
        });

        $ctrl.runReport = (report) => {
            sessionStorage.setItem("__report", JSON.stringify(report));

            $state.go("Home.Reports.Results");
        };
        
        $ctrl.reportFilter = (report) => {
            if (!$ctrl.searchText) return true;
            $ctrl.searchText = !!$ctrl.searchText ? $ctrl.searchText.toLowerCase() : '';
            if (report.Name.toLowerCase().indexOf($ctrl.searchText) !== -1
                || report.CreatedBy.FirstName.toLowerCase().indexOf($ctrl.searchText) !== -1
                || report.CreatedBy.LastName.toLowerCase().indexOf($ctrl.searchText) !== -1
                || (report.ModifiedOn && report.ModifiedOn.indexOf($ctrl.searchText) !== -1)
            ) return true;
            return false;
        };

        $ctrl.$onInit = () => {
            $ctrl.ui.loading = true;

            $ctrl.reports = [];

            const promises = [
                reportApi.getPublicReports(),
                reportApi.getUserReports($ctrl.currentUser.Id),
                reportApi.getUserSharedReports($ctrl.currentUser.Id)
            ];

            $q.all(promises)
                .then(responses => {
                    var _reports = [
                        ...responses[0],
                        ...responses[1],
                        ...responses[2].map(report => report.Report)
                    ];

                    // remove duplicate reports when a user makes a report public
                    _reports.forEach(function (report) {
                        var i = $ctrl.reports.findIndex(x => x.Id === report.Id);
                        if (i <= -1) {
                            $ctrl.reports.push(report);
                        }
                    });
                })
                .finally(() => $ctrl.ui.loading = false);
        };
    }

})(window.app, window.angular);